<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
    >
    </page-main>
  </div>
</template>
<script>
import PageMain from './main.vue'

export default {
  components: {
    PageMain,
  },
  props: {
    mrpFabricPlanDetailCode: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      usePage: true,
      loading: false,
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .mrpFabricPlanScheduleListApi({
          mrpFabricPlanDetailCode: this.mrpFabricPlanDetailCode,
          ...form
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  }
}
</script>
